import Homepage from "Pages/Common/Home/Index";
import Login from "Pages/Common/Login/Login";
import About from "Pages/Common/AboutUs/About";
import WhyUs from "Pages/Common/whyUs/Whyus";
import AdvanceTaxplanning from "Pages/Common/AdvanceTaxPlanning/Planning";
import FederalTax from "Pages/Common/PreparationofFederalTax/Federal";
import IrsAdudit from "Pages/Common/IrsAudit/Audit";
import Itin from "Pages/Common/PreparationOfItin/Itin";
import Extension from "Pages/Common/ExtensionTaxreturns/extension";
import FbarCommon from "Pages/Common/Fbar/fbar";
import FTar from "Pages/Common/Ftar/fbar";
import NonResident from "Pages/Common/Nonresident/nonresident";
import Pricing from "Pages/Common/Pricing/pricing";
import Contact from "Pages/Common/Contact/Contact";
import Payroll from "Pages/Common/PayrollService/Payroll";
import Signup from "Pages/Common/SignUp/Signup";
import Dashboard from "Pages/Auth/Dashboard/dashboard";
import PersonalInfo from "Pages/Auth/Basic-info/PersonalInfo";
import DependantInfo from "Pages/Auth/Basic-info/DependantInfo";
import AddDependant from "Pages/Auth/Basic-info/Adddependent";
import BankInfo from "Pages/Auth/Basic-info/BankInfo";
import Fbar from "Pages/Auth/Basic-info/Fbar";
import OtherIncome from "Pages/Auth/OtherInfo/Otherinfo";
import Expenses from "Pages/Auth/OtherInfo/Expenses";
import RentalInfo from "Pages/Auth/OtherInfo/RentalIncome";
import UploadDoc from "Pages/Auth/UploadDoc/UploadDoc";
import TaxSummary from "Pages/Auth/TaxSummary/TaxSummary";
import Referral from "Pages/Auth/Referral/Referral";
import Settings from "Pages/Auth/Settings/Settings";
import FbarAdd from "Pages/Auth/Basic-info/AddFbar";
import Resetpassword from "Pages/Common/Login/ResetPassword";
import ResetpasswordVerify from "Pages/Common/Login/ResetPasswordVerify";
import Messages from "Pages/Auth/Messages/Messages";
import ClientDoc from "Pages/Auth/ReviewDoc/UploadDoc";
import AmendmentTaxReturns from "Pages/Common/amendmentTaxReturns/Planning";
import TaxReturns from "Pages/Common/BusinessTaxreturns/TaxReturns";
import AnnualFiling from "Pages/Common/AnnualFiling/TaxReturns";
import BookkeepingService from "Pages/Common/bookkeepingService/BookService";
import BusinessRegistration from "Pages/Common/New-Business-Registration/Registration";
import RefundPolicy from "Pages/Common/refund-policy/Federal";
import TermsConditions from "Pages/Common/Terms_Conditions/Federal";
import PrivacyPolicy from "Pages/Common/privacy-policy/Federal";
import prevDoc from "Pages/Auth/UploadDoc/prevDoc";
import PaymentSuccess from "Pages/Common/Payments/PaymentSuccess";
import PaymentFailure from "Pages/Common/Payments/PaymentFailure";
import Contributions from "Pages/Auth/OtherInfo/Contributions";
export const Config = [
    {
        path: "/",
        element: Homepage,
    },
    {
        path: "/Login",
        element: Login,
    },
    {
        path: "/terms-conditions",
        element: TermsConditions,
    },
    {
        path: "/Bookkeeping-Services",
        element: BookkeepingService,
    },
    {
        path: "/New-Business-Registration",
        element: BusinessRegistration,
    },
    {
        path: "/refund-policy",
        element: RefundPolicy,
    },
    {
        path: "/Business-tax-returns",
        element: TaxReturns,
    },
    {
        path: "/Annual-filing-or-Franchise-taxes",
        element: AnnualFiling,
    },
    {
        path: "/filing-of-amendment-tax-returns-claim-for-refund",
        element: AmendmentTaxReturns,
    },
    {
        path: "/reset-password",
        element: Resetpassword,
    },
    {
        path: "/reset-password-verify",
        element: ResetpasswordVerify,
    },

    {
        path: "/sign-up",
        element: Signup,
    },
    {
        path: "/about-us",
        element: About,
    },
    {
        path: "/privacy-policy",
        element: PrivacyPolicy,
    },
    {
        path: "/why-serene",
        element: WhyUs,
    },
    {
        path: "/Advance-tax-planning",
        element: AdvanceTaxplanning,
    },
    {
        path: "/Preparation-of-federal-and-state-tax-returns",
        element: FederalTax,
    },
    {
        path: "/irs-audit-representation",
        element: IrsAdudit,
    },
    {
        path: "/preparation-of-itin",
        element: Itin,
    },
    {
        path: "/extension-of-tax-returns",
        element: Extension,
    },
    {
        path: "/FBAR",
        element: FbarCommon,
    },
    {
        path: "/FATCA",
        element: FTar,
    },
    {
        path: "/non-resident",
        element: NonResident,
    },
    {
        path: "/Pricing",
        element: Pricing,
    },
    {
        path: "/Contact",
        element: Contact,
    },
    {
        path: "/payroll-services",
        element: Payroll,
    },
];

export const AuthRoutes = [
    {
        path: "/payment-success",
        element: PaymentSuccess,
    },
    {
        path: "/payment-failure",
        element: PaymentFailure,
    },

    {
        path: "/dashboard",
        element: Dashboard,
    },
    {
        path: "/review-doc",
        element: ClientDoc,
    },
    {
        path: "/basic-info/Profile-info",
        element: PersonalInfo,
    },
    {
        path: "/basic-info/dependent-info",
        element: DependantInfo,
    },
    {
        path: "/basic-info/dependent-info/add",
        element: AddDependant,
    },
    {
        path: "/basic-info/bank-details",
        element: BankInfo,
    },
    {
        path: "/basic-info/fbar",
        element: Fbar,
    },
    {
        path: "/basic-info/fbar-info/add",
        element: FbarAdd,
    },
    {
        path: "/other-info/other-income",
        element: OtherIncome,
    },
    {
        path: "/other-info/expense",
        element: Expenses,
    },
    {
        path: "/other-info/Contributions",
        element: Contributions,
    },
    {
        path: "/other-info/rental-income",
        element: RentalInfo,
    },
    {
        path: "/upload-document",
        element: UploadDoc,
    },
    {
        path: "/previous-doc",
        element: prevDoc,
    },
    {
        path: "/Tax-Summary",
        element: TaxSummary,
    },
    {
        path: "/Referral",
        element: Referral,
    },
    {
        path: "/settings",
        element: Settings,
    },
    {
        path: "/message",
        element: Messages,
    },
];
